import { Select, SelectMenuItem } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../Translations';
import { SsoEnvironment } from '../Types';

interface Props {
  selected: SsoEnvironment;
  onSelect: (environment: SsoEnvironment) => void;
}

const EnvironmentPicker: React.FC<Props> = ({ selected, onSelect }) => (
  <div>
    <span className="mb-2 block text-sm font-semibold text-foreground">
      <T kind="Environment" />
    </span>
    <div data-intercom-target="sso-environment-dropdown">
      <Select
        multiple={false}
        value={selected}
        onChange={(value) => onSelect(value === 'staging' ? 'staging' : 'production')}
        renderValue={(value) =>
          value === 'staging' ? <T kind="Staging / test" /> : <T kind="Production" />
        }
      >
        <SelectMenuItem value="production" selected={selected === 'production'}>
          <T kind="Production" />
        </SelectMenuItem>
        <SelectMenuItem value="staging" selected={selected === 'staging'}>
          <T kind="Staging / test" />
        </SelectMenuItem>
      </Select>
    </div>
    <p className="mt-2 text-xs text-muted-foreground">
      <T kind="Most connections are Production. Choose Staging / test if this connection is for your IdP's test tenant - it keeps the connection clearly labeled everywhere." />
    </p>
  </div>
);

export default observer(EnvironmentPicker);
